var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('div',{staticClass:"menu flex"},_vm._l((_vm.menu),function(item,index){return _c('router-link',{key:index,staticClass:"item",attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])}),1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }